import React from 'react';
import { Breadcrumb, Layout, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import Loading from '../../common/Loading';

import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

class ActualizarDatosPersona extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
  };

  onCancel = () => {
    this.setState({
      fase: 0,
    });
  };

  guardarPersona = persona => {
    if (persona) {
      notification.success({
        message: 'Persona actualizada correctamente',
      });
    } else {
      notification.warning({
        message: 'Error al actualizar los datos de la persona',
      });
    }
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Persona</Breadcrumb.Item>
          <Breadcrumb.Item>Actualizar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Actualizacion de Datos Persona
          </h2>
          <br />
          <div style={estiloContent}>
            <BuscarYCrearPersona obtenerPersona={this.guardarPersona} />
          </div>
        </Layout>
      </div>
    );
  }
}

export default ActualizarDatosPersona;
